export function formatNumber(value: number | string | null): string {
	if(!value) return '--';
	return value.toString();
}